var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMongodb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1479_21496)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.7715 50C39.5786 50 50.7715 38.8071 50.7715 25C50.7715 11.1929 39.5786 0 25.7715 0C11.9644 0 0.771484 11.1929 0.771484 25C0.771484 38.8071 11.9644 50 25.7715 50Z",
    fill: "#13AA52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4546 21.9453C30.8755 14.9761 27.1436 12.6846 26.7417 11.8091C26.3023 11.1914 25.857 10.0928 25.857 10.0928C25.8497 10.0742 25.8379 10.0415 25.8243 10.0098C25.7789 10.6274 25.7554 10.8657 25.1714 11.4888C24.2671 12.1958 19.6275 16.0889 19.2501 24.0068C18.898 31.3916 24.5845 35.792 25.3536 36.353L25.441 36.415V36.4097C25.4459 36.4468 25.6851 38.1675 25.8531 39.9907H26.4556C26.597 38.7019 26.8089 37.4219 27.0904 36.1562L27.1392 36.1245C27.4832 35.8779 27.8112 35.6096 28.1211 35.3213L28.1563 35.2896C29.7911 33.7793 32.73 30.2861 32.7012 24.7168C32.6951 23.7878 32.6127 22.8608 32.4546 21.9453ZM25.7891 32.1836C25.7891 32.1836 25.7891 21.8262 26.1309 21.8281C26.3975 21.8281 26.7427 35.188 26.7427 35.188C26.2681 35.1309 25.7891 32.9893 25.7891 32.1836Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1479_21496"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(0.771484)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMongodb);
export default __webpack_public_path__ + "static/media/mongodb.287fcc0ef1dc962de8dd2f0057126dd4.svg";
export { ForwardRef as ReactComponent };